"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const markdownItAttrs = require('markdown-it-attrs');
const utils_1 = require("./utils");
const CTARenderer = md => {
  let ctaDetected = false; // flag used to sync link_open and link_close link
  md.use(markdownItAttrs);
  const defaultRenderer = (tokens, idx, options, env, self) => {
    return self.renderToken(tokens, idx, options);
  };
  const defaultLinkOpenRender = md.renderer.rules.link_open || defaultRenderer;
  const defaultLinkCloseRender = md.renderer.rules.link_close || defaultRenderer;
  // custom renderer for CTA links open token
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    if (token.attrIndex('CTA') > -1 && token.attrs) {
      ctaDetected = true;
      const addition = ['button', 'is-primary', 'is-loaded'];
      token.attrs.splice(token.attrIndex('CTA'), 1); // Avoid CTA attr to be outputed as html attr
      (0, utils_1.replaceClassToToken)(token, addition);
      return `<span class="buttons has-text-centered"><a${self.renderAttrs(token)} type="button" style="text-decoration: none; padding: 0 16px; font-weight: 600; margin: 24px auto;">`;
    }
    // pass token to default renderer.
    return defaultLinkOpenRender(tokens, idx, options, env, self);
  };
  // custom renderer for CTA links close token
  md.renderer.rules.link_close = (tokens, idx, options, env, self) => {
    if (ctaDetected) {
      ctaDetected = false;
      return `</a></span>`;
    }
    // pass token to default renderer.
    return defaultLinkCloseRender(tokens, idx, options, env, self);
  };
};
exports.default = CTARenderer;
